import configdata from "../../config.json";
import { cartoonTypeSliceAction } from "./CartoonTypeSlice";
import { getApi } from "../BaseApi";
import { getOnlyValueFromSelectObject } from "../UseAbleFun";
import { appLevelSliceActions } from "../AppLevelApi/AppLevelSlice";

export const getAllCartoonTypeItems = () => {
  return async (dispatch) => {
    // dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/cartoon-types`
    );

    // dispatch(appLevelSliceActions.setLoadingState());
    // dispatch(cartoonTypeSliceAction.getAllCartoonType(res.data.cartoonType));
  };
};
export const createCartoonTypeItem = (data) => {
  return async (dispatch) => {
    const { form } = getOnlyValueFromSelectObject(data);
    // dispatch(appLevelSliceActions.setLoadingState());
    const resData = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/cartoon-types/store`,
      form
    );
    if (resData?.error) {
      if (resData?.errorType === "single") {
        // dispatch(
        //   appLevelSliceActions.setError({ msg: resData.message, isError: true })
        // );
      } else {
        // dispatch(
        //   cartoonTypeSliceAction.setErrorData({
        //     message: resData.message,
        //     isError: true,
        //   })
        // );
      }

      // dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    // dispatch(
    //   cartoonTypeSliceAction.setErrorData({
    //     message: {},
    //     isError: false,
    //   })
    // );
    // dispatch(cartoonTypeSliceAction.setInitialData());
    // dispatch(appLevelSliceActions.setIsSuccess(true));

    // dispatch(appLevelSliceActions.setLoadingState());
    // dispatch(getAllCartoonTypeItems());
  };
};
export const getDataForEdit = (id, productList) => {
  return async (dispatch) => {
    // dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/cartoon-types/edit/${id}`
    );
    // dispatch(appLevelSliceActions.setLoadingState());
    const data = { ...res.data.cartoonType[0] };

    const product = productList.find((item) => {
      return item.value === data.product_id;
    });

    data.status = {
      value: `${data.status}`,
      label: data.status === "active" ? "Active" : "Deactive",
      type: "status",
    };

    data.product = {
      value: product.value,
      label: product.label,
      type: product.type,
    };

    // dispatch(cartoonTypeSliceAction.getCartoonTypeDataEdit(data));
  };
};

export const updateCartoonTypeItem = (data) => {
  const { form } = getOnlyValueFromSelectObject(data);

  return async (dispatch) => {
    // dispatch(appLevelSliceActions.setLoadingState());
    const resData = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/cartoon-types/update/${data.id}`,
      form
    );
    if (resData?.error) {
      if (resData?.errorType === "single") {
        // dispatch(
        //   appLevelSliceActions.setError({ msg: resData.message, isError: true })
        // );
      } else {
        // dispatch(
        //   cartoonTypeSliceAction.setErrorData({
        //     message: resData.message,
        //     isError: true,
        //   })
        // );
      }

      // dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    // dispatch(
    //   cartoonTypeSliceAction.setErrorData({
    //     message: {},
    //     isError: false,
    //   })
    // );
    // dispatch(cartoonTypeSliceAction.setInitialData());
    // dispatch(appLevelSliceActions.setIsSuccess(true));

    // dispatch(appLevelSliceActions.setLoadingState());
    // dispatch(getAllCartoonTypeItems());
  };
};

export const deleteCartoonTypeItem = (id) => {
  return async (dispatch) => {
    // dispatch(appLevelSliceActions.setLoadingState());
    await getApi(
      "get",
      `${configdata.SERVER_URL}/api/cartoon-types/delete/${id}`
    );
    // dispatch(appLevelSliceActions.setIsSuccess(true));
    // dispatch(appLevelSliceActions.setLoadingState());
  };
};
